import { render, staticRenderFns } from "./Voucher.vue?vue&type=template&id=ed50b068&scoped=true&"
import script from "./Voucher.vue?vue&type=script&lang=js&"
export * from "./Voucher.vue?vue&type=script&lang=js&"
import style0 from "./Voucher.vue?vue&type=style&index=0&id=ed50b068&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed50b068",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ed50b068')) {
      api.createRecord('ed50b068', component.options)
    } else {
      api.reload('ed50b068', component.options)
    }
    module.hot.accept("./Voucher.vue?vue&type=template&id=ed50b068&scoped=true&", function () {
      api.rerender('ed50b068', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4hF4RzGF0ycu7/JS/comp/Voucher.vue"
export default component.exports